var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "拼团订单信息",
        visible: _vm.dialogVisible,
        size: "800",
        "with-header": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "infinite-list",
          staticStyle: { overflow: "auto", height: "100vh" },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t拼团名称：" +
                            _vm._s(_vm.formData.combinationName) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.formData.pinkStatusName) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t拼团商品:\t" +
                            _vm._s(_vm.formData.productName) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t拼团小程序:\t" +
                            _vm._s(_vm.formData.appName) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t拼图团团长：" +
                            _vm._s(_vm.formData.promoterName) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t拼团时间: " +
                            _vm._s(_vm.formData.pinkDate) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "box-text-center" }, [
            _c(
              "div",
              { staticClass: "box-chie" },
              [
                _c(
                  "el-form",
                  { attrs: { "label-width": "80px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v("\n\t\t\t\t\t\t拼团信息\n\t\t\t\t\t"),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.formData.combinationStatusName) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t拼团时效：" +
                              _vm._s(_vm.formData.effectiveTime) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t拼团人数：" +
                              _vm._s(_vm.formData.pinkPeople) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t单用户参与次数：" +
                              _vm._s(_vm.formData.quota) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t补齐人数：" +
                              _vm._s(_vm.formData.fillPeople) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t单次购买上限：" +
                              _vm._s(_vm.formData.onceQuota) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t物流方式：" +
                              _vm._s(_vm.formData.logisticsName) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t运费设置：" +
                              _vm._s(_vm.formData.shippingName) +
                              "\n\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "description-center" },
            [
              _c("span", [_vm._v("今日总览")]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "box-center-options" }, [
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("今日浏览量")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [
                    _vm._v(_vm._s(_vm.formData.todayView.browse)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("今日订单")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [
                    _vm._v(_vm._s(_vm.formData.todayView.orderCount)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("今日成交额")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [
                    _vm._v(_vm._s(_vm.formData.todayView.totalAmount)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("今日转化率")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [
                    _vm._v(_vm._s(_vm.formData.todayView.conversionRate)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "description-center" },
            [
              _c(
                "div",
                { staticClass: "description-title" },
                [
                  _c("span", [_vm._v("效果总览")]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "220px", height: "34px" },
                    attrs: {
                      size: "small",
                      type: "daterange",
                      placement: "bottom-end",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                    },
                    on: { change: _vm.onchangeTime },
                    model: {
                      value: _vm.timeVal,
                      callback: function ($$v) {
                        _vm.timeVal = $$v
                      },
                      expression: "timeVal",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "box-center-options" }, [
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("累计浏览量")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [_vm._v("2")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("累计订单量")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [_vm._v("2")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("累计成交额")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [_vm._v("2")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-box-options" }, [
                  _c("span", [_vm._v("转化率")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "box-box-text" }, [_vm._v("2")]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "description",
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("商品明细")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.listDataNew.pinkPage.list,
                        size: "mini",
                        "highlight-current-row": "",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "uid", label: "ID", "min-width": "40" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "uname",
                          label: "用户",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "avatar",
                          label: "用户头像",
                          "min-width": "80",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return _c("el-avatar", {
                                attrs: { size: "small", src: scope.row.avatar },
                              })
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productName",
                          label: "商品",
                          "min-width": "140",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderNo",
                          label: "订单编号",
                          "min-width": "140",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalPrice",
                          label: "订单金额",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "paidPrice",
                          label: "实付金额",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderStatus",
                          label: "订单状态",
                          "min-width": "80",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return _c("span", {}, [
                                _vm._v(
                                  _vm._s(
                                    _vm.transformState(
                                      _vm.orderStateOption,
                                      scope.row.orderStatus,
                                      "value"
                                    )
                                  )
                                ),
                              ])
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.listPram.page,
                      "page-sizes": _vm.constants.page.limit,
                      layout: _vm.constants.page.layout,
                      total: _vm.listDataNew.pinkPage.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "flex-btw" }, [
                _c("div", { staticClass: "title" }, [_vm._v("流转日志")]),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.listDataNew.logList,
                    size: "mini",
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "时间",
                      "min-width": "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "用户", "min-width": "200" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "log", label: "操作", "min-width": "200" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pinkId",
                      label: "编号",
                      "min-width": "200",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }